import React from "react";
import ProjectCard from "../cards/ProjectCard";
import { websitePaths } from "../../../routes/websitePaths";

const projects = [
  {
    title: "Residential Villa",
    descList: [
      "Premium exterior and interior finishing standards",
      "Optimized room planning for natural ventilation",
      "Energy-conscious material and lighting selection",
    ],
    image: "/images/IMG-20251110-WA0006.jpg.jpeg",
    link: websitePaths.projects.residential,
  },
  {
    title: "Luxury Residence",
    descList: [
      "Customized layout focused on family comfort",
      "Elegant facade with durable construction details",
      "Integrated utility planning for daily convenience",
    ],
    image: "/images/20231022_152856.jpg.jpeg",
    link: websitePaths.projects.residential,
  },
  {
    title: "Corporate Office",
    descList: [
      "Efficient floor planning for collaborative workflows",
      "Modern structural and electrical infrastructure",
      "Professional finish for long-term business use",
    ],
    image: "/images/IMG-20251110-WA0006.jpg.jpeg",
    link: websitePaths.projects.commercial,
  },
  {
    title: "Industrial Warehouse",
    descList: [
      "High-load flooring and robust utility integration",
      "Logistics-first movement and storage configuration",
      "Safety-focused circulation and compliance planning",
    ],
    image: "/images/IMG-20251110-WA0006.jpg.jpeg",
    link: websitePaths.projects.industrial,
  },
];

const ProjectsSection: React.FC = () => (
  <section id='projects' className='container my-5'>
    <h3 className='text-center website-section-title'>Our Featured Projects</h3>
    <p className='text-center website-section-subtitle mb-4'>
      A selection of home, commercial, and industrial work that reflects our
      planning, finish quality, and execution standards.
    </p>
    <div className='row g-4'>
      {projects.map((project) => (
        <ProjectCard key={`${project.title}-${project.image}`} {...project} />
      ))}
    </div>
  </section>
);

export default ProjectsSection;
